import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeAdminSession } from "@/lib/adminAuth";

/** Processes the Emergent Auth session_id fragment once, then redirects to
 * /admin. REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR
 * REDIRECT URLS, THIS BREAKS THE AUTH. */
export default function AdminAuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/admin", { replace: true });
        return;
      }
      try {
        const user = await exchangeAdminSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      } catch (err) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { authError: err.message } });
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="admin-auth-callback" className="min-h-screen flex items-center justify-center bg-[#0D1B2A]">
      <p className="text-white/60 text-sm tracking-[0.14em] uppercase">Signing you in…</p>
    </div>
  );
}
